export const defaultConfigState = {
	ConfigInfo: {
		CurrentDate: new Date(),
		CurrentDateText: '',
		HkdConfig: null
	}
};

export default {
	...defaultConfigState
};
